import { Injectable } from '@angular/core';
import { PaymentHistoryRequest } from 'src/app/core/models/request/payment-history.request';

@Injectable()
export class PaymentsFilterService {
  private savedRequest: PaymentHistoryRequest;

  public saveFilter(request: PaymentHistoryRequest) {
    this.savedRequest = request;
  }

  public getSavedFilter(): PaymentHistoryRequest {
    return this.savedRequest;
  }
}
